<div class="popup-header">
  <div class="title">
    {{data.name}}
  </div>
</div>

<div mat-dialog-content>
  <br>


  <div class="input-group  mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm">Name</span>
    </div>
    <input type="text" class="form-control" aria-label="Small" [(ngModel)]="data.localSystemId" disabled
      aria-describedby="inputGroup-sizing-sm">
  </div>

  <div class="input-group  mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm">companyName</span>
    </div>
    <input type="text" class="form-control" aria-label="Small" [(ngModel)]="data.companyName" disabled
      aria-describedby="inputGroup-sizing-sm">
  </div>


  <div class="input-group  mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm">siteName</span>
    </div>
    <input type="text" class="form-control" aria-label="Small" [(ngModel)]="data.siteName" disabled
      aria-describedby="inputGroup-sizing-sm">
  </div>

  <div class="input-group  mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm">Monthly renew</span>
    </div>
    <input *ngIf="isCreditRenew()" type="text" class="form-control" value="Yes (credit renewal is always monthly)" disabled>
    <select *ngIf="!isCreditRenew()" class="custom-select"   [(ngModel)]="data.renewalMonthly"  id="inputGroupSelect01">
      <option selected>Choose...</option>
      <option value=true>Yes</option>
      <option value=false>No</option>
    </select>
    <!-- <input type="text" class="form-control" aria-label="Small" [(ngModel)]="data.renewalMonthly" 
      aria-describedby="inputGroup-sizing-sm"> -->
  </div>



  <div class="input-group  mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm">Renewal Hour</span>
    </div>
    <input type="number" class="form-control" aria-label="Small" [(ngModel)]="data.setHour" 
      aria-describedby="inputGroup-sizing-sm">
  </div>

</div>
<div mat-dialog-actions align="end">
  <button class="theme-button" (click)="runnow(data)" cdkFocusInitial>Run now</button>

  <button class="theme-button" (click)="updateCategory(data)" cdkFocusInitial>Save</button>
  <button mat-button (click)="onNoClick()">Close</button>

</div>